import { ChevronDown, ChevronUp } from "lucide-mui";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useState, type ReactNode } from "react";

interface ExpandableRowProps {
  /** The row's cells after the expand toggle. */
  cells: ReactNode;
  /** Total columns, toggle included. */
  colSpan: number;
  children: ReactNode;
}

/** A table row with a chevron that reveals `children` in a full-width row below. */
export default function ExpandableRow({ cells, colSpan, children }: ExpandableRowProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <ChevronUp /> : <ChevronDown />}
          </IconButton>
        </TableCell>
        {cells}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={colSpan}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ m: 2 }}>{children}</Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
